<div>
  <div class="w-100 mx-auto" style="max-width: 500px">
    <mat-form-field appearance="fill" class="d-block">
      <mat-label>Plate Style</mat-label>
      <mat-select [disabled]="loading" [(ngModel)]="plateStyle" (selectionChange)="plateStyleChanged($event)">
        <mat-option [value]="'dateless'">Dateless</mat-option>
        <mat-option [value]="'current'">Current</mat-option>
        <mat-option [value]="'prefix'">Prefix</mat-option>
        <mat-option [value]="'suffix'">Suffix</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="text-center">
      <mat-progress-spinner class="mx-auto" [mode]="'indeterminate'" *ngIf="loading" ></mat-progress-spinner>
      <span>This may take a while, it does a lot of filtering</span>
    </div>

    <div class="d-flex gap-2 justify-content-center align-items-center">
      <button [disabled]="loading || !results || results.length === 0" class="d-block btn btn-lg btn-outline-primary" (click)="exportResults()">Export</button>
    </div>
  </div>

  <div>
    <h4 *ngIf="!loading">Unique Plates {{ uniqueResultCount }}. Total Sales {{ results.length }}</h4>
    <table mat-table [dataSource]="results" class="mt-3 w-100">

      <!-- Registration Column -->
      <ng-container matColumnDef="registration">
        <th mat-header-cell *matHeaderCellDef> Registration</th>
        <td mat-cell class="ps-0 pe-1" *matCellDef="let plate">
          <pla-plate [rawPlate]="plate.formattedRegistration" [showPrice]="false" [mobileSmall]="true"
                     [smallPlate]="false" [showPercentage]="false" [customClass]="'flat shaded'" [plateSize]="'smaller'"
                     [noMargin]="true" [openModal]="false"></pla-plate>
        </td>
      </ng-container>

      <!-- Sold Date Column -->
      <ng-container matColumnDef="sold_price">
        <th mat-header-cell *matHeaderCellDef> Sold Price</th>
        <td mat-cell class="ps-0 pe-1" *matCellDef="let plate"> {{ plate.sold_price / 100 | currency: 'GBP' }}</td>
      </ng-container>

      <!-- Num Of Sales Column -->
      <ng-container matColumnDef="num_sales">
        <th mat-header-cell *matHeaderCellDef> Number of Sales</th>
        <td mat-cell *matCellDef="let plate"> {{ plate.num_sales | number }}</td>
      </ng-container>

      <!-- Sold Date Column -->
      <ng-container matColumnDef="sold_date">
        <th mat-header-cell *matHeaderCellDef> Sold Date</th>
        <td mat-cell class="ps-0 pe-1" *matCellDef="let plate"> {{ plate.sold_date | date: 'dd/MM/yyyy' }}</td>
      </ng-container>

      <!-- Seller Column -->
      <ng-container matColumnDef="seller">
        <th mat-header-cell *matHeaderCellDef> Seller</th>
        <td mat-cell class="px-0" *matCellDef="let plate">
          <ng-container [ngSwitch]="plate.sale_type">
            <span class="lh-sm" *ngSwitchCase="0">DVLA AUCTION (PRE SCRAPE)</span>
            <span class="lh-sm" *ngSwitchCase="1">DVLA SALE</span>
            <span class="lh-sm" *ngSwitchCase="2">PLATEX SALE</span>
            <span class="lh-sm" *ngSwitchCase="3">THIRD PARTY ({{ plate.seller }})</span>
            <span class="lh-sm" *ngSwitchCase="4">CURRENTLY LISTED</span>
            <span class="lh-sm" *ngSwitchCase="5">INITIAL PRICE</span>
            <span class="lh-sm" *ngSwitchCase="6">{{ plate.seller }}</span>
            <span class="lh-sm" *ngSwitchCase="7">THIRD PARTY AUCTION ({{plate.seller}})</span>
            <span class="lh-sm" *ngSwitchCase="8">PRICE CHANGE</span>
            <span class="lh-sm" *ngSwitchCase="9">CUSTOM SELLER ({{plate.seller}})</span>
            <span class="lh-sm" *ngSwitchCase="10">{{plate.seller}}</span>
            <span class="lh-sm" *ngSwitchCase="100">MANUAL IMPORT {{plate.seller}}</span>
            <span class="lh-sm" *ngSwitchDefault>UNKNOWN</span>
          </ng-container>
        </td>
      </ng-container>

      <!-- Header and Row Definitions -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>
